import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminListArticles, adminListFaqs, adminListResources } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ articles: 0, faqs: 0, resources: 0 });

  useEffect(() => {
    Promise.all([
      adminListArticles().catch(() => []),
      adminListFaqs().catch(() => []),
      adminListResources().catch(() => []),
    ]).then(([a, f, r]) => setStats({ articles: a.length, faqs: f.length, resources: r.length }));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="overline">Overview</div>
      <h1 className="font-serif-editorial tight-track mt-4" style={{ fontSize: "clamp(2.2rem, 4vw, 3.5rem)", lineHeight: 1 }}>
        Welcome back.
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        <Link to="/admin/articles" className="group block p-10 border" data-testid="dash-articles" style={{ borderColor: "rgba(166,154,139,0.5)", backgroundColor: "var(--sand)" }}>
          <div className="overline">Editorial</div>
          <div className="font-serif-editorial mt-4" style={{ fontSize: "3.5rem", lineHeight: 1 }}>{stats.articles}</div>
          <div className="mt-4 text-lg">Articles</div>
          <div className="mt-10 overline flex items-center gap-2">Manage <ArrowRight size={14} /></div>
        </Link>
        <Link to="/admin/resources" className="group block p-10 border" data-testid="dash-resources" style={{ borderColor: "rgba(166,154,139,0.5)", backgroundColor: "var(--sand)" }}>
          <div className="overline">Store</div>
          <div className="font-serif-editorial mt-4" style={{ fontSize: "3.5rem", lineHeight: 1 }}>{stats.resources}</div>
          <div className="mt-4 text-lg">Resources</div>
          <div className="mt-10 overline flex items-center gap-2">Manage <ArrowRight size={14} /></div>
        </Link>
        <Link to="/admin/faqs" className="group block p-10 border" data-testid="dash-faqs" style={{ borderColor: "rgba(166,154,139,0.5)", backgroundColor: "var(--sand)" }}>
          <div className="overline">Reference</div>
          <div className="font-serif-editorial mt-4" style={{ fontSize: "3.5rem", lineHeight: 1 }}>{stats.faqs}</div>
          <div className="mt-4 text-lg">FAQs</div>
          <div className="mt-10 overline flex items-center gap-2">Manage <ArrowRight size={14} /></div>
        </Link>
      </div>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <div className="overline">Quick actions</div>
          <div className="mt-6 flex flex-wrap gap-4">
            <Link to="/admin/articles/new" className="btn-olive" data-testid="quick-new-article">New article</Link>
            <Link to="/admin/resources/new" className="btn-outline" data-testid="quick-new-resource">New resource</Link>
            <Link to="/admin/faqs/new" className="btn-outline" data-testid="quick-new-faq">New FAQ</Link>
          </div>
        </div>
        <div>
          <div className="overline">Notes</div>
          <p className="mt-6 text-sm opacity-80" style={{ lineHeight: 1.7 }}>
            Upload PDFs and cover images from the resource editor. Buyers automatically receive a signed download link by email.
          </p>
        </div>
      </div>
    </div>
  );
}
